import type SearchProvider from '../data/schema/SearchProvider';
import type SearchRequestInstrumentation from '../data/schema/SearchRequestInstrumentation';
import type SubstrateSearchScenario from '../data/schema/SubstrateSearchScenario';
import { getClientId, getClientVersion } from 'owa-config';

/**
 * Build the instrumentation data for a specific search request
 * @param response - The Response object
 * @param jsonRequest - The JSON request
 * @param errorMessage - The Error message in the body (if any)
 * @param clientRequestStart - Start time for when client initiated the network request
 * @param clientRequestFinish - End time for when the client received network response
 * @param clientQueryId - The search query id
 * @param pageNumber - Page number for search results
 */
export const buildInstrumentation = (
    response: Response | undefined,
    query: string,
    errorMessage: string | undefined,
    provider: SearchProvider,
    clientRequestStart: number,
    clientRequestFinish: number,
    searchQueryId: string,
    clientRequestHeaders: Headers,
    pageNumber: number,
    substrateSearchScenario: SubstrateSearchScenario
): SearchRequestInstrumentation => {
    const responseHeader = response?.headers || new Headers();

    const searchRequestInstrumentation: SearchRequestInstrumentation = {
        ClientSearchProvider: provider,
        PageNumber: pageNumber,
        ClientNetworkTime: clientRequestFinish - clientRequestStart,
        ClientJSEndToEndTime: 0, // Populated separately later
        ClientJSPreRequestTime: 0, // Populated separately later
        ClientJSRequestThreadTime: 0, // Populated separately later
        ClientResponseProcessTime: 0, // Populated separately later
        ClientJSRenderingTime: 0, // Populated separately later
        SearchDateTime: responseHeader.get('date') ?? '',
        SearchBETarget: responseHeader.get('x-calculatedbetarget') ?? '',
        SearchFETarget: responseHeader.get('x-calculatedfetarget') ?? '',
        SearchBEHttpStatus: responseHeader.get('x-backendhttpstatus') ?? '',
        SearchMsEdgeRef: responseHeader.get('x-msedge-ref') ?? '',
        SearchErrorContent: errorMessage,
        SearchTraceID: responseHeader.get('request-id') ?? '',
        SearchQueryId: searchQueryId,
        ClientBuildNumber: getClientVersion(),
        ClientHttpStatus: response?.status || -1, // Ensure ClientHttpStatus isn't undefined.
        SearchClientRequestID: clientRequestHeaders.get('client-request-id') ?? '',
        SearchClientSessionID: getClientId() ?? '',
        ClientName: substrateSearchScenario,
        DiagnosticsCheckpoints: responseHeader.get('x-ms-diagnostics-checkpoints') ?? '',
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (389,9): Type 'null' is not assignable to type 'CalculatedResourceTimings'.
        // @ts-expect-error
        ResourceTimingEntry: null,
        PIIData: {
            queryText: query,
        },
        LogicalId: '',
    };

    return searchRequestInstrumentation;
};
